module.exports = __webpack_public_path__ + "0b7fb32f68199271e45381dcd464dfe4.svg";